export const INVITATION_LANGUAGES = [
  {
    code: "en",
  },
  {
    code: "es",
  },
  {
    code: "ca",
  },
  {
    code: "fr",
  },
];
